export default class HoveredButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="ihop2-hovered-button-container" >
                <a href="#"><button type="button" className="btn btn-danger" data-toggle="modal"
        data-target="#recordnone">{this.props.buttonText}</button></a>
            </div>
        );
    }
}
